import Vue from 'vue'

import ImageButton from './ImageButton.vue'

import SdAppSnap from './SdAppSnap.vue'
import SdAttributePanel from './SdAttributePanel.vue'
import SdAddressSearch from './SdAddressSearch.vue'
import SdBaseLayers from './SdBaseLayers.vue'
import SdCoordinate from './SdCoordinate.vue'
import SdFoldCards from './SdFoldCards.vue'
import SdGeometryEditor from './SdGeometryEditor.vue'
import SdLayerTree from './SdLayerTree.vue'
import SdLayerConfigDialog from './SdLayerConfigDialog.vue'
import SdMap from './SdMap.vue'
import SdOverlay from './SdOverlay.vue'
import SdOverlay2 from './SdOverlay2.vue'
import SdOverlays from './SdOverlays.vue'
import SdQueryPanel from './SdQueryPanel.vue'
import SdScale from './SdScale.vue'
import SdTemporaryEditor from './SdTemporaryEditor.vue'
import SdToolBar from './SdToolBar.vue'
import SdToolMenu from './SdToolMenu.vue'
import SdThematicTree from './SdThematicTree.vue'

const components = {
  ImageButton,
  SdAppSnap,
  SdAttributePanel,
  SdAddressSearch,
  SdBaseLayers,
  SdCoordinate,
  SdFoldCards,
  SdGeometryEditor,
  SdLayerTree,
  SdLayerConfigDialog,
  SdMap,
  SdOverlay,
  SdOverlay2,
  SdOverlays,
  SdQueryPanel,
  SdScale,
  SdTemporaryEditor,
  SdToolBar,
  SdToolMenu,
  SdThematicTree
}

for (const [key, value] of Object.entries(components)) {
  Vue.use({
    install: function (Vue) {
      Vue.component(key, value)
    },
  })
}